export const NET_PARTNER = "10047";
export const NET_PARTNER_KEY = "avsafag#$";



// WEBPACK FOOTER //
// ./src/assets/js/requestConfig.js